import React from "react";
import { Box, Grid, Typography, Stack, Button } from "@mui/material";
import Image22 from "../images/Image-26.webp";
import { motion } from "framer-motion";
import '../css/ReferAndEarn.css';
import { fadeInLeft } from "../animations/motionConfigs";
import StillNotSurePopUpv2 from "./Popup/StillNotSurePopUpv2";
import { EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT } from "../../constants/AzureDevops";

export default function StillNotSure(props) {
    const { isSmallScreen, course } = props;
    const [open, setOpen] = React.useState(false);

    return (
        <Box
            sx={{
                maxWidth: isSmallScreen ? "90%" : "70%",
                mx: "auto",
                mt: course=== EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT ? 10 : isSmallScreen ? 0 : 4,
                mb: 8,
                position: "relative",
            }}
        >
            <Grid
                container
                sx={{
                    borderRadius: "20px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    overflow: "visible",
                    alignItems: "stretch",
                    p: { xs: 3, md: 6 },
                    position: "relative",
                    bgcolor: "#F8EFFF",
                }}
            >
                <Grid item xs={12} md={7}>
                    <motion.div {...fadeInLeft} >
                        <Typography
                            variant={isSmallScreen ? "h4" : "h3"}
                            sx={{
                                fontWeight: 700,
                                mb: isSmallScreen ? 2 : 3,
                                fontFamily: "Poppins, sans-serif",
                                color: "#6B3399",
                            }}
                        >
                            Still Not Sure?
                        </Typography>
                    </motion.div>
                    <motion.div {...fadeInLeft} style={{ fontWeight: 700, fontSize: "18px", lineHeight: 1.5, marginBottom: isSmallScreen ? 0 : "1rem", fontFamily: "Poppins, sans-serif", }}>
                        Talk to Our Expert Consultant
                    </motion.div>

                    <motion.div {...fadeInLeft} style={{ fontSize: "16px", lineHeight: 1.5, display: "flex", alignItems: "flex-end", gap: "8px", fontFamily: "Poppins, sans-serif", }}>
                        We’re here to help you make the right <br /> move for your career.
                    </motion.div>
                    <motion.div {...fadeInLeft} style={{ fontSize: "16px", lineHeight: 1.5, fontFamily: "Poppins, sans-serif", }}>
                        No pressure, just honest guidance.
                    </motion.div>

                    <motion.div {...fadeInLeft}>
                        <Button
                            aria-label="Chat with a Mentor Now"
                            onClick={() => setOpen(true)}
                            className="referAndEarnButtonV2"
                            variant="contained"
                            sx={{
                                color: "black",
                                bgcolor: "#DAADFF",
                                margin: "2rem auto",
                                py: 1,
                                fontWeight: 600,
                                fontSize: "18px",
                                textTransform: "none",
                                borderRadius: "20px",
                                "&:hover": {
                                    opacity: 0.9,
                                    bgcolor: "#B255FF",
                                },
                                width: isSmallScreen ? "100%" : "auto"
                            }}>
                            Chat with a Mentor Now
                        </Button>
                    </motion.div>

                </Grid>

                {/* Right side - Image */}
                {!isSmallScreen && <Grid
                    item
                    xs={12}
                    md={5}
                    sx={{
                        position: "relative",
                        display: "flex",
                        alignItems: "flex-end", // Stick image to bottom
                        justifyContent: "center",
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            bottom: "-90px",
                            right: "-70px",
                        }}
                    >
                        <motion.div
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5 }}
                        >
                            <img
                                loading="lazy"
                                src={Image22}
                                alt="Bootcamp Student"
                                style={{
                                    width: "600px",
                                    height: "auto",
                                    borderRadius: "20px",
                                }}
                            />
                        </motion.div>
                    </Box>
                </Grid>}
            </Grid>
            <StillNotSurePopUpv2
                isSmallScreen={isSmallScreen}
                open={open}
                onClose={() => setOpen(false)}
            />
        </Box>
    );
}
